/* eslint-disable react/require-default-props */
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const FormGroup = React.forwardRef(({
  children,
  orientation,
  gap,
  ...rest
}, ref) => {

  const isHorizontal = orientation === 'horizontal';
  const isVertical = orientation === 'vertical';
  const classes = classNames('sui-flex sui-flex-wrap', {
    'sui-flex-col': isVertical,
    'sui-flex-row': isHorizontal,
    'sui-gap-y-2': isVertical && gap,
    'sui-gap-x-6': isHorizontal && gap,
  });

  return (
    <div
      data-testid="form-group"
      ref={ref}
      {...rest}
      className={classes}
    >
      {children}
    </div>
  );
});

FormGroup.displayName = 'FormGroup';

FormGroup.propTypes = {
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * The orientation of the children
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  /**
   * If true, sui-gap-y-2 added to vertical or sui-gap-x-6 added to horizontal
   */
  gap: PropTypes.bool
};

FormGroup.defaultProps = {
  orientation: 'vertical',
  gap: true
};

export { FormGroup };